<template>
    <rkm-area
        title="Data desejada"
        type="fieldset"
    >
        <rkm-row>
            <rkm-col cols="auto">
                <rkm-form-checkbox v-model="data.model.obrigaDataDesejada">
                    Obrigar preenchimento
                </rkm-form-checkbox>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <GrupoExame :data="data" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <ProcedimentoCirurgico :data="data" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <Especialidade :data="data" />
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <Infraestrutura :data="data" />
            </rkm-col>
        </rkm-row>
    </rkm-area>
</template>

<script>
// Components.
import GrupoExame from './components/grupo-exame/Index'
import ProcedimentoCirurgico from './components/procedimento-cirurgico/Index'
import Especialidade from './components/especialidade/Index'
import Infraestrutura from './components/infraestrutura/Index'

export default {
    components: { GrupoExame, ProcedimentoCirurgico, Especialidade, Infraestrutura },
    props: {
        data: { type: Object, required: true },
    }
}
</script>